import type {ComponentProps, FC} from 'react';

interface FormErrorProps extends ComponentProps<'span'> {}

const FormError: FC<FormErrorProps> = ({children}) => (
  <span className="text-xs text-red-400 text-left float-left -mt-2 p-1">{children}</span>
);

export default FormError;
